

  // Function to remove aria-label if present
function removeAriaLabel(link) {
    if (link.hasAttribute('aria-label')) {
        link.removeAttribute('aria-label');
        console.log('Removed aria-label from link:', link.href);
    }
}

// Observe the entire document for added attributes or nodes
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        // Check added nodes
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
                // If it's a product link
                if (node.matches && node.matches('a.product__media')) {
                    removeAriaLabel(node);
                }
                // Also check descendants of added nodes
                node.querySelectorAll && node.querySelectorAll('a.product__media').forEach(removeAriaLabel);
            }
        });

        // Check attribute changes
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
            if (mutation.target.matches('a.product__media')) {
                removeAriaLabel(mutation.target);
            }
        }
    });
});

// Start observing
observer.observe(document.body, {
    childList: true, // Watch for added/removed nodes
    subtree: true,   // Watch all descendants
    attributes: true // Watch attribute changes
});

